"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DirtClasses = function (_Component) {
  (0, _inherits3.default)(DirtClasses, _Component);

  function DirtClasses() {
    (0, _classCallCheck3.default)(this, DirtClasses);
    return (0, _possibleConstructorReturn3.default)(this, (DirtClasses.__proto__ || (0, _getPrototypeOf2.default)(DirtClasses)).apply(this, arguments));
  }

  (0, _createClass3.default)(DirtClasses, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tietoa palvelusta" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Maalajiluokitukset"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Maapo\u0308rssin sivustolla ilmoittaessa on maa-aineksen koostumus tarkennettava. Tarkennuksessa voi kuvata maa-ainesta omin sanoin. Tarvittaessa voit vaikka kirjoittaa \u201DValitse tyyppi\u201D -tiputusvalikosta valitsemasi termin, kuten \u201Dlouhe\u201D."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Esimerkkeja\u0308 \u201DMaa-aineksen tarkennus:\u201D -kenta\u0308ssa\u0308 ka\u0308ytetyista\u0308 kuvauksista:"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "div",
                { className: "col col-xs-12  col-lg-6" },
                "Kantavaa moreenia rakennekerroksiin ",
                _react2.default.createElement("br", null),
                "Mara-asetuksen mukaista betonimursketta",
                _react2.default.createElement("br", null),
                "Savi 70% / moreeni 30%",
                _react2.default.createElement("br", null),
                "Kivinen moreeni",
                _react2.default.createElement("br", null),
                "Louhittua kivea\u0308, ei kovin isoa",
                _react2.default.createElement("br", null),
                "Hyva\u0308a\u0308 moreenia",
                _react2.default.createElement("br", null),
                "Pienlouhetta",
                _react2.default.createElement("br", null),
                _react2.default.createElement("br", null)
              ),
              _react2.default.createElement(
                "div",
                { className: "col col-xs-12 col-lg-6" },
                "Pintamaata, myo\u0308hemmin moreenia",
                _react2.default.createElement("br", null),
                "Hiekkainen moreeni",
                _react2.default.createElement("br", null),
                "Sekalaista ta\u0308ytto\u0308maata",
                _react2.default.createElement("br", null),
                "Kiveto\u0308n ta\u0308ytemaa",
                _react2.default.createElement("br", null),
                "Kantava ta\u0308ytemaa",
                _react2.default.createElement("br", null),
                "Moreenia pihan tasaamiseksi",
                _react2.default.createElement("br", null),
                "Kantavaan kerrokseen betonimursketta",
                _react2.default.createElement("br", null),
                _react2.default.createElement("br", null)
              )
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "p",
              null,
              "Mita\u0308 aikaisemmin ilmoituksen ja\u0308tta\u0308a\u0308, sita\u0308 pidempa\u0308a\u0308n ilmoituksella on aikaa lo\u0308yta\u0308a\u0308 sopiva lukija. Ilmoituksen ja\u0308tto\u0308a\u0308 ei kannata lyka\u0308ta\u0308 vain, koska maasta paljastuvan maa-aineksen koostumus ei ole viela\u0308 tarkasti tiedossa. Maa-aineksen tarkennus on tarkoitettu vain arvioksi josta voi keskustella tarkemmin, kun ilmoitus hera\u0308tta\u0308a\u0308 kiinnostusta. Ta\u0308sta\u0308 huolimatta olemme lisa\u0308nneet maalajikuvaukset ta\u0308lle sivustolle."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Virallisesti maalajit luokitellaan eri ryhmiin niiden syntytavan, sisa\u0308lta\u0308ma\u0308n elopera\u0308isen aineksen ja raekoostumuksen perusteella. Ta\u0308ssa\u0308 luokittelussa ka\u0308yteta\u0308a\u0308n kahta pa\u0308a\u0308luokkaa: kivenna\u0308ismaalajit ja elopera\u0308iset maalajit. Kivenna\u0308ismaalajit ovat syntyneet kalliopera\u0308sta\u0308 irronneesta ja hienontuneesta kiviaineksesta. Suomessa ta\u0308ma\u0308 on pa\u0308a\u0308osin johtunut ja\u0308a\u0308tiko\u0308sta\u0308 ja sen sulamisesta. Elopera\u0308ista\u0308 ainesta kertyy maahan kasvien kuolleiden lehtien, oksien, ela\u0308inten ja muun elopera\u0308isen maatumisen tuloksena."
            ),
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Kivenna\u0308ismaalajit"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Hiekka (Hk)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Hiekka on hienojakoista kivimursketta. Hiekka muodostuu mineraaleista tai kivenna\u0308israkeista joiden koko on 0,2-2,0 mm. Yksitta\u0308ista\u0308 raetta kutsutaan hiekanjyva\u0308ksi. 0,2-06 mm rakeista hiekkaa kutsutaan hienohiekaksi (HHk) ja 0,6-2,0 mm hiekkaa karkeahiekaksi (KHk). Hienohiekka sisa\u0308lta\u0308a\u0308 yleensa\u0308 va\u0308ha\u0308n hiesua ja saveakin (noin 5 %). Hiekka on suosituin rakennusten pohjissa ka\u0308ytetta\u0308va\u0308 materiaali. Hiekkaa ka\u0308yteta\u0308a\u0308n muun muassa rakennusten perustusten suodatinkerroksena, ympa\u0308rys- ja sisa\u0308ta\u0308ytto\u0308ihin seka\u0308 putkien, kaapeleiden ympa\u0308rysta\u0308ytto\u0308ihin, teiden suodatinkerrokseen, imeytyskenttiin ja uimarantoihin."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Hiesu (Hs)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Hiesumaan maalajitteen koko on 0,002-0,02 mm. Saveksen osuus hiesusta on noin 20 -30 painoprosenttia. Yleisimpia\u0308 hiesuisia maalajeja ovat hietainen hiesu, savinen hiesu ja liejuhiesu. Na\u0308issa\u0308 maalajeissa hiesua on noin 40-60 %."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Savi (Sa)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Savi koostuu la\u0308pimitaltaan 0,002 mm tai pienemmista\u0308 rakeista. Karkea savi on raekooltaan 0,0002- 0,002mm ja hienosavi alle 0,0002 mm. Aitosavessa (AS) saveksen osuus on yli 60 %, hiesua 20 % ja loput hietaa. Hietasavessa (HtS) savea on yleensa\u0308 noin 30-40 % ja Hiesusavessa yleensa\u0308 (HsS) 40-60 %. Hietalajitteen osuuden ollessa merkitta\u0308va\u0308, ka\u0308yteta\u0308a\u0308n joskus termia\u0308 hietainen hiesusavi. Elopera\u0308ista\u0308 ainesta (noin 2-6 %) sisa\u0308lta\u0308va\u0308a\u0308 savea kutsutaan Liejusaveksi (lijHs) joka on syntynyt ja\u0308a\u0308kauden ja\u0308lkeen ja\u0308rvien ja jokien rannoille. Hienorakenteisuudestaan johtuen savi imee itseensa\u0308 liuenneita aineita ja kaasuja. Saven kyky imea\u0308 muun muassa alkalisuoloihin kuuluvia kaliumsuoloja antaa mahdollisuuden ka\u0308ytta\u0308a\u0308 savea kasveille ravinteikkaana maa-aineksena."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Siltti (Si)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Siltti on eritta\u0308in hienojakoista hiekkaa. Siltin raekoko on 0,002-0,063 mm. Siltti voidaan jakaa viela\u0308 tarkemmin karkeaan silttiin (CSi) 0,02-0,063 mm, keskisilttiin (MSi) 0,0063-0,02 mm ja hienoon silttiin (FSi) 0,002-0,0063 mm. Siltti soveltuu ta\u0308ytemaaksi esimerkiksi nurmikoiden alla ja ratsastusmaneesissa."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Sora (Sr)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Sora on hiekkaa suurempaa kivimursketta jonka raekoko on 2-20 mm tai joidenkin lukitusten mukaan jopa 60 mm asti. Soraa suuremmat rakeet luokitellaan kiviksi tai kivimurskeeksi. Sora on hyvin vetta\u0308 la\u0308pa\u0308iseva\u0308 maalaji ja siksi routimatonta maa-ainesta. Sora sopii routimattomuutensa takia hyvin teiden pintamateriaalina ja rakennuspohjana."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Moreeni (Mr)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Moreenimaa eli moreeni on useiden eri maalajien sekoitus. Moreeni on syntynyt mannerja\u0308a\u0308tiko\u0308n ensin irrotettua kiviainesta kalliopera\u0308sta\u0308 ja ta\u0308ma\u0308n ja\u0308lkeen liikkuessaan hienontaen sen moreeniksi. Moreenimaan sisa\u0308lta\u0308ma\u0308t kivet ovat sa\u0308rmikka\u0308ita\u0308 ja kivenpintaan on iskostunut hienoainesta. Koska moreeni on lujittamaton maalaji (eli sen rakeiden va\u0308liin ja\u0308a\u0308 tyhja\u0308a\u0308 tilaa) sekoittuu moreeniin luonnossa useitakin eri maalajeja. Yleensa\u0308 moreeninlajit luokitellaan sen mukaan mita\u0308 maalajia sekoitteessa on eniten; soramoreeni (SrMr) koostuu useista soramoreeneista ja sen raekoko vaihtelee 2-20 mm va\u0308lilla\u0308 ja hiekan 0,2-2 mm va\u0308lilla\u0308, karkeassa hietamoreenissa hiedan raekoko vaihtelee 0,06-20 mm ja hiekan 0,06-0,2 mm va\u0308lilla\u0308, hienon hietamoreenin hiedan raekoko vaihtelee 0,002-0,06 mm va\u0308lilla\u0308, savimoreenin (SMr) raekoko on eninta\u0308a\u0308n 0,002 mm, karkeassa hiekkamoreenissa (HkMr) hiedan raekoko vaihtelee 0,06-20 mm va\u0308lilla\u0308 ja hiekan 0,06-0,2 mm va\u0308lilla\u0308, hienossa hietamoreenissa raekoko on 0,002-0,06 mm va\u0308lilla\u0308, hiesumoreenin (HsMr) raekoko vaihtelee 0,0002-0,002 mm va\u0308lilla\u0308. Moreenia voi ka\u0308ytta\u0308a\u0308 esimerkiksi ta\u0308ytemaana rakennusten ympa\u0308rilla\u0308 seka\u0308 nurmikon alla tai patorakennelmissa."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Louhikko, kivikko, kalliomurske tai louhe (Lo)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Louhe on alun perin kalliosta ra\u0308ja\u0308ytta\u0308ma\u0308lla\u0308 irrotettua kiviainesta joka on koneellisesti murskattu erikokoiseksi kalliomurskeeksi. Louhetta ka\u0308yteta\u0308a\u0308n muun muassa rakennusten pohjato\u0308ihin, aallonmurtajiin, aitoihin seka\u0308 erilaisissa luiskissa."
            ),
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Elopera\u0308iset maalajit"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Humusmaat"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Humus on orgaanista eli elopera\u0308sita\u0308 maa-ainesta. Humusmaat voidaan jakaa ainakin kolmeen luokkaan: multamaihin, saraturpeisiin ja rahkaturpeisiin."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Lieju (Lj)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Kasvien ja ela\u0308inten ja\u0308a\u0308nno\u0308ksista\u0308 seka\u0308 kivenna\u0308isaineksesta ja\u0308rvien ja merien pohjaan syntynytta\u0308 kerrostumaa kutsutaan liejuksi. Liejun luokittelemiseksi elopera\u0308iseksi maa-ainekseksi riitta\u0308a\u0308 6 painoprosentin osuus elopera\u0308ista\u0308 maa-ainesta. Jos elopera\u0308ista\u0308 ainesta on va\u0308hemma\u0308n, luokitellaan myo\u0308s lieju kivenna\u0308ismaalajeihin. Ta\u0308llo\u0308in kyseessa\u0308 on liejuinen hieta, liejuhiesu tai liejusavi."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Multa (Mm)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Multamaaksi luokitellaan maalaji jossa va\u0308hinta\u0308a\u0308n 20 painoprosenttia on elopera\u0308ista\u0308 ainesta. Multamaa on yleensa\u0308 syntynyt ihmisen muokattua soista viljelysmaata jolloin turve ja kivenna\u0308ismaa ovat sekoittuneet. Multaan kuuluvat maalajit joiden painoprosentista 20 on elopera\u0308ista\u0308 ainesta. Multaa voidaan ka\u0308ytta\u0308a\u0308 kasvualustana nurmikolle ja muille kasveille."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Turve (Tv)"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Turve luokitellaan kahteen pa\u0308a\u0308luokkaan saraturpeeseen ja rahkaturpeeseen. Saraturve jakautuu nelja\u0308a\u0308 tyyppiin: ruskosammalsaraturve (BCt), saraturve (Ct), metsa\u0308saraturve (LCt) ja rahkasaraturve (SCt). Rahkaturpeet puolestaan jaetaan kolmeen tyyppiin: sararahkaturve (CSt), metsa\u0308rahkaturve (LSt) ja rahkaturve (St). Turvetta ka\u0308yteta\u0308a\u0308n maataloudessa kuivikkeena, imeytysaineena ja kompostoinnissa, puutarha- ja avomaaviljelyssa\u0308 kasvualustana, maanparannusaineena ja lannoitteena, viherrakentamisessa ja maisemoinnissa."
            ),
            _react2.default.createElement(
              "h1",
              { className: "h2" },
              "Muut ma\u0308a\u0308ritykset"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Routiva ja routimaton maa-aines"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Routiva maa-aines on maa-ainesta joka imee vetta\u0308 ja siksi la\u0308mpo\u0308tilan ollessa miinusasteilla laajenee ja\u0308a\u0308tymisen seurauksena. Va\u0308a\u0308ra\u0308ssa\u0308 rakennuskohteessa ka\u0308ytettyna\u0308 routiva maa-aines aiheuttaa veden ja\u0308a\u0308tyessa\u0308 vahinkoa. Routimaton maa-aines ei puolestaan sido nestetta\u0308 vaan pa\u0308a\u0308sta\u0308a\u0308 sen valumaan la\u0308pi. Siksi routimattomat maa-ainekset soveltuvat kohteisiin joissa maa-aineksen ei sallita laajentuvan la\u0308mpo\u0308tilan laskiessa miinusasteille."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Ta\u0308ytemaa, hienota\u0308ytemaa ja karkea ta\u0308ytemaa"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Ta\u0308ytemaa on la\u0308hto\u0308kohtaisesti routivaa kivenna\u0308ismaata kuten moreenia tai savea, mutta voi olla myo\u0308s elopera\u0308ista\u0308. Routimattomia ta\u0308ytemaita ovat hienota\u0308ytemaa ja karkeata\u0308ytemaa. Hienota\u0308ytemaa on kiviainesta joka voi sisa\u0308lta\u0308a\u0308 silttipaakkuja ja yksitta\u0308isia\u0308 isojakin kivia\u0308. Karkeata\u0308ytemaa on hienota\u0308ytemaata kivisempa\u0308a\u0308 ta\u0308ytemaata. Ta\u0308ytemaata ka\u0308yteta\u0308a\u0308n rakentamisessa esimerkiksi nurmi ja muiden kasvialustojen alkuta\u0308yto\u0308issa\u0308. Ta\u0308ytemaan ka\u0308ytto\u0308 alkukerroksissa on mullan ka\u0308ytto\u0308a\u0308 edullisempaa. Ta\u0308ytemaista voidaan rakentaa myo\u0308s valleja ja kumpareita."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Pintamaa"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Pintamaat ovat luonnollisen maannoksen yla\u0308osa. Va\u0308rilta\u0308a\u0308n pintamaat ovat yleensa\u0308 tummia ja niiden orgaanisen aineksen ja ravinteiden sisa\u0308lto\u0308 on suurempi kuin alapuolisissa kerrostumissa lukuun ottamatta humuskerrosta. Pintamaita ka\u0308yteta\u0308a\u0308n yleisesti viherrakentamisessa kasvukerrosten alapuolella lisa\u0308a\u0308ma\u0308a\u0308n ravinteikasta kasvupohjaa."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Lecasora"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Lecasora on kaupallinen tuote jota voidaan hyo\u0308dynta\u0308a\u0308 infrarakentamisessa maapera\u0308nkeventa\u0308miseen ja roudan erista\u0308miseen."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Kuivakuorisavi"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Kuivakuorisavella tarkoitetaan kerrosta joka on yleensa\u0308 kasvukerroksen ja varsinaisen pohjasaven va\u0308lissa\u0308. Kuivakuorisavea ka\u0308yteta\u0308a\u0308n yleisesti viherrakentamiseen seulottavien multien raaka-aineena sitomaan kosteutta."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Kitkamaa"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Kitkamaat ovat maalajeja joiden rakeiden yhdista\u0308va\u0308na\u0308 voimana toimii rakeiden va\u0308linen kitka. Kitkamailla on kitkakulma, joka riippuu mm. maarakeiden muodosta ja karheudesta. Kitkamaihin lukeutuvat mm. hiekka, sora, kivet ja moreeni. Kitkamaiden vastakohtia ovat koheesiomaat (esimerkiksi savi) joiden koossapita\u0308va\u0308 voima on kitkan lisa\u0308ksi maapartikkeleiden va\u0308linen koheesio."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Suodatinhiekka"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Suodatinhiekka on hiekkaa jossa ei ole savea. Suodatinhiekka sisa\u0308lta\u0308a\u0308 elopera\u0308ista\u0308 maata tai isoja kivia\u0308 ja on routimatonta."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Hiekoitussepeli"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Hiekoitussepeli eli hiekoitushiekka on hiekoituksessa ka\u0308ytettya\u0308 hiekkaa. Hiekka kera\u0308ta\u0308a\u0308n yleensa\u0308 lumen mukana lumenla\u0308jityspaikoille joista hiekka hyo\u0308dynneta\u0308a\u0308n muiden ainesten jalostuksessa tai vieda\u0308a\u0308n kaatopaikalle."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Asfalttirouhe"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Asfalttirouhe on asfalttia jyrsitta\u0308essa\u0308 syntyva\u0308a\u0308 mursketta. Asfalttirouhetta voidaan uusioka\u0308ytta\u0308a\u0308 uuden asfaltin valmistuksessa."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Maakivet"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Maakivet ovat maasta kaivettuja luonnonkivia\u0308. Maakivet ovat la\u0308pimitaltaan 60-600 mm. Maakivia\u0308 voidaan ka\u0308ytta\u0308a\u0308 muun muassa koristekivina\u0308 ja murskata murskeeksi."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Betonimurske"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Betonimurske on rakennusten purkutyo\u0308n myo\u0308ta\u0308 syntyva\u0308a\u0308 mursketta. Puhdas betonimurske soveltuu rakentamisessa esimerkiksi penkkaan, jakavaan kerrokseen ja kantavaan kerrokseen. Hallien maapohjat ja tiet ovat esimerkkeja\u0308 rakennuskohteista joissa voidaan ka\u0308ytta\u0308a\u0308 betonimursketta."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Kivenna\u0308ismaalajit"
            ),
            _react2.default.createElement(
              "table",
              { className: "table" },
              _react2.default.createElement(
                "thead",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "th",
                    null,
                    "Maalaji"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Lyhennys"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Rakeiden la\u0308pimitta (mm)"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Elopera\u0308ista\u0308 ainesta p-%"
                  )
                )
              ),
              _react2.default.createElement(
                "tbody",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Savi"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Sa"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "\u2264 0,002"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "\u22642"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Siltti"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Si"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,002-0,06"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "\u22642"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hiekka"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hk"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,06-2,0"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hienohiekka"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "HHk"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,2-0,6"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Karkeahiekka"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "KHk"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,6-2,0"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Sora"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Sr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "2,0-60,0"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Kivet (tai kivikko)"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Ki"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "60-600"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Lohkareet (tai louhikko)"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Lo"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 600"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Silttimoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "SiMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "\u2264 0,06"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hiekkamoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "HkMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,06-2,0"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Soramoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "SrMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 2,0"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hietamoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "HtMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    " "
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hiesumoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "HsMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    " "
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Savimoreeni"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "SMr"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    " "
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hiesu"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hs"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,002-0,02"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hieta"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Ht"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,02-0,2"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hieno hieta"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "HHt"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,02-0,06"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Karkea hieta"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "KHt"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "0,06-0,2"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  )
                )
              )
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Elopera\u0308iset maalajit"
            ),
            _react2.default.createElement(
              "table",
              { className: "table" },
              _react2.default.createElement(
                "thead",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "th",
                    null,
                    "Maalaji"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Lyhennys"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Rakeiden la\u0308pimitta (mm)"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Elopera\u0308ista\u0308 ainesta p-%"
                  )
                )
              ),
              _react2.default.createElement(
                "tbody",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Turve"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Tv"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 40"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Lieju"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Lj"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 20"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Savinen lieju"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "saLj"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 6-20"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Silttinen lieju"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "siLj"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 6-20"
                  )
                ),
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "td",
                    null,
                    "Humusmaa"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "Hm"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "-"
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    "> 20"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return DirtClasses;
}(_react.Component);

exports.default = DirtClasses;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/DirtClasses/DirtClasses.js
 ** module id = 1212
 ** module chunks = 0
 **/